import dayjs, { Dayjs } from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrAfter);

import { BookingScheduleStatus, BookingScheduleTypeVo, NonFaceToFaceDiagnosisBookingSchedulesVo } from '@/types/doctor';

export type DateInput = string | Date | Dayjs | undefined | null;

export const findClosestAvailableScheduleByDate = (
  schedules: Array<NonFaceToFaceDiagnosisBookingSchedulesVo>,
  dateToSelect?: DateInput
): NonFaceToFaceDiagnosisBookingSchedulesVo | null => {
  if (!schedules?.length) {
    return null;
  }

  if (dateToSelect) {
    const base = dayjs(dateToSelect);
    const matched = schedules
      .filter((schedule) => dayjs(schedule.targetDate).isSameOrAfter(base, 'day'))
      .find((schedule) => schedule.status === BookingScheduleStatus.Bookable);

    if (matched) {
      const hasBookableSlots = matched.schedules.some((slot) => slot.bookingStatus === BookingScheduleTypeVo.Bookable);
      if (hasBookableSlots) {
        return matched;
      }
      return null;
    }
  }

  for (const schedule of schedules) {
    if (schedule.status === BookingScheduleStatus.Bookable) {
      const hasBookableSlots = schedule.schedules.some((slot) => slot.bookingStatus === BookingScheduleTypeVo.Bookable);
      if (hasBookableSlots) {
        return schedule;
      }
    }
  }

  return null;
};
